import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import { ProductionApiAlert } from 'components/Development';
import { persistor, store } from 'store';
import GlobalStyles from 'styles/global';
import AppRoutes from './routes';
import { QueryClientProvider, QueryClient } from 'react-query';

toast.configure();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ProductionApiAlert />
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <QueryClientProvider client={new QueryClient()}>
            <GlobalStyles />
            <AppRoutes />
          </QueryClientProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

export default App;
